import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

interface NavigationHeaderProps {
  onBack?: () => void
  showBack?: boolean
}

export function NavigationHeader({ onBack, showBack = true }: NavigationHeaderProps) {
  return (
    <div className="flex items-center justify-center gap-4 mb-4">
      <div className="flex gap-2">
        {showBack && onBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="h-8 w-8 opacity-60 hover:opacity-100"
            title="Voltar"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
